import { solana, solanaDevnet } from '@reown/appkit/networks';

// Toggle this to switch between devnet and mainnet for local development
const USE_MAINNET_FOR_DEV = false;

export default {
  IS_DEV: true,
  API_BASE_URL: 'http://localhost:3000',
  //API_BASE_URL: 'https://api.nonprod.junk.fun',
  SOLANA_NETWORK: USE_MAINNET_FOR_DEV ? solana : solanaDevnet,
  // For mainnet, set VITE_SOLANA_RPC_URL in .env.local
  SOLANA_RPC_URL: USE_MAINNET_FOR_DEV
    ? import.meta.env?.VITE_SOLANA_RPC_URL
    : 'https://api.devnet.solana.com',
  SOLANA: {
    PROGRAM: {
      JUNK_FUN_PROGRAM_ID: 'junkTHpAet6MuYuTfHej12Zh12aWeG6tXbB7hnLjTKi',
    },
  },
  // Developer Testing: Force pre-launch gate to show
  // Toggle this to true to always show the gate with a dismiss button
  FORCE_PRELAUNCH_GATE: false, // <-- TOGGLE THIS ON/OFF
  // Feature Flags
  ENABLE_NEW_LEADERBOARDS: false, // Enable burned/cumulative points leaderboards
  ENABLE_NFT_DEBUG_BYPASS: true, // Bypass Twitter verification for NFT minting in nonprod
  ENABLE_NFT_JUNKING: true, // Development: Enable NFT junking for testing
  ENABLE_SOLFLARE_CAMPAIGN: false, // Solflare campaign has ended
  ENABLE_GATE_WALLET_CAMPAIGN: true, // Show Gate Wallet connect button
  ENABLE_SMB_MATRICA_CAMPAIGN: true, // Test SMB x Matrica campaign locally
  ENABLE_MATTLE_CAMPAIGN: true, // Test Mattle.fun campaign locally
  ENABLE_PHANTOM_EMBEDDED_WALLET: true,
  ENABLE_DUST_SWAP: true, // UI enabled for testing, functionality is mocked on devnet
  ENABLE_RECLAIM_EXCESS_RENT: true, // Excess rent reclaim panel (SPL WithdrawExcessLamports)
  SHOW_SWAP_PDA_BALANCE: true, // Show user's accumulated swap PDA balance for testing
  ENABLE_PNFT_JUNKING: false, // pNFT burning is not supported by the current on-chain burn flow
  SHOW_ASSET_DISCOVERY_DEBUG: true, // Show asset discovery source while debugging locally
  // Jupiter API version: 'ultra' (faster, single call) or 'legacy' (2-step quote→swap)
  JUPITER_API_VERSION: 'legacy' as 'ultra' | 'legacy',
  ENABLE_WRAPPED: false, // Enable Wrapped 2025 feature
  WRAPPED_END_DATE: '2026-01-07T23:59:59Z', // When Wrapped becomes archived (set to 2026 for dev testing)
  ENABLE_NEW_YEAR_CAMPAIGN: false, // New Year 2026 Campaign ended
  // NFT Tier Thresholds (must match backend constants)
  NFT_TIER_THRESHOLDS: {
    DIAMOND: 2,
    BLACK: 4,
    GOLD: 6,
    SILVER: 8,
  },
  // WalletConnect metadata for nonprod environment
  WALLET_CONNECT_METADATA: {
    name: 'Junk.Fun (NonProd)',
    description: 'Junk.Fun - Burn tokens, win prizes',
    url: 'https://nonprod.junk.fun',
    icons: ['https://www.junk.fun/logo.png'], // Using prod logo (nonprod is behind Vercel auth)
  },
};
